import { call, cancelled, delay, put, takeLatest } from "redux-saga/effects";
import { getSensorInterpolationApi } from "../../../api/fieldDataApi";
import { logout } from "../../../store/features/auth/authSlice";
import {
  fetchSensorHeatmapStart,
  fetchSensorHeatmapSuccess,
  fetchSensorHeatmapFailure,
  resetSensorHeatmapState,
} from "../../../store/features/customer/sensorHeatmap/sensorHeatmapSlice";
import { parseApiError } from "../../utils";

export function* fetchSensorHeatmapSaga(action) {
  if (action.type !== fetchSensorHeatmapStart.type) return;
  const controller = new AbortController();
  const { requestId } = action.payload;
  try {
    const attempts = action.payload.retryOnEmpty ? 2 : 1;
    for (let attempt = 0; attempt < attempts; attempt += 1) {
      try {
        const data = yield call(
          getSensorInterpolationApi,
          action.payload,
          controller.signal,
        );
        yield put(fetchSensorHeatmapSuccess({ requestId, data }));
        return;
      } catch (error) {
        if (attempt === attempts - 1 || error.response?.status !== 404) throw error;
        yield delay(1000);
      }
    }
  } catch (error) {
    const isEmpty = error.response?.status === 404;
    const message = isEmpty
      ? "Nessun dato per questa ora"
      : error.response || error.request
        ? parseApiError(error)
        : error.message;
    yield put(
      fetchSensorHeatmapFailure({
        requestId,
        isEmpty,
        error: message || "Impossibile caricare la heatmap",
      }),
    );
  } finally {
    if (yield cancelled()) controller.abort();
  }
}

// Reset/logout also match takeLatest so they abort the active request.
export default function* sensorHeatmapSaga() {
  yield takeLatest(
    [
      fetchSensorHeatmapStart.type,
      resetSensorHeatmapState.type,
      logout.type,
    ],
    fetchSensorHeatmapSaga,
  );
}
